let ctx: AudioContext | null = null;

/**
 * Lazily initializes and returns the AudioContext.
 * Returns null if window is not defined (server-side).
 */
export const getAudioContext = (): AudioContext | null => {
    if (typeof window === 'undefined') return null;

    if (!ctx) {
        const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
        if (AudioContextClass) {
            ctx = new AudioContextClass();
        }
    }
    return ctx;
};

/**
 * Plays a sound with a gain boost.
 * Safe to call on server (does nothing).
 */
export const playBoostedSound = (src: string) => {
    if (typeof window === 'undefined') return;

    const context = getAudioContext();
    if (!context) return;

    try {
        const audio = new Audio(src);
        const source = context.createMediaElementSource(audio);

        const gainNode = context.createGain();
        gainNode.gain.value = 2;

        source.connect(gainNode);
        gainNode.connect(context.destination);

        audio.play().catch(() => { });
    } catch (error) {
        console.error("Failed to play boosted sound:", error);
    }
};